import { createSlice } from "@reduxjs/toolkit";
import type { Insurer } from "./type";

const toOption = (item: any) => ({
  value: item?.id ?? item?.value,
  label: item?.name ?? item?.display_name ?? item?.label ?? "",
});

const initialState = {
  insurerList: { data: [], total: 0 },
  insurer_options: [] as any[],
  insurer_service_options: [] as any[],
  selectedInsurer: null as Insurer | null,
};

const insurerSlice = createSlice({
  name: "insurerSlice",
  initialState,
  reducers: {
    insurerList(state, action) {
      const payload = action.payload;
      const next = Array.isArray(payload)
        ? { data: payload, total: payload.length }
        : payload || { data: [], total: 0 };
      state.insurerList = next;
      const list = Array.isArray(next?.data) ? next.data : [];
      state.insurer_options = list.map(toOption);
    },
    insurerServiceList(state, action) {
      const payload = action.payload;
      const next = Array.isArray(payload)
        ? { data: payload, total: payload.length }
        : payload || { data: [], total: 0 };
      const list = Array.isArray(next?.data) ? next.data : [];
      state.insurer_service_options = list.map(toOption);
    },
    selectedInsurer(state, action) {
      state.selectedInsurer = action.payload;
    },
    addInsurer(state, action) {
      state.insurerList.data = [action.payload, ...(state.insurerList.data || [])];
      state.insurerList.total = Number(state.insurerList.total || 0) + 1;
      state.insurer_options = (state.insurerList.data || []).map(toOption);
    },
    updateInsurer(state, action) {
      const payload = action.payload;
      state.insurerList.data = (state.insurerList.data || []).map((item: any) =>
        item?.id === payload?.id ? { ...item, ...payload } : item
      );
      state.insurer_options = (state.insurerList.data || []).map(toOption);
    },
    deleteInsurer(state, action) {
      const id = action.payload;
      state.insurerList.data = (state.insurerList.data || []).filter(
        (item: any) => item?.id !== id
      );
      state.insurerList.total = Math.max(0, Number(state.insurerList.total || 0) - 1);
      state.insurer_options = (state.insurerList.data || []).map(toOption);
    },
  },
});

export const {
  insurerList,
  insurerServiceList,
  selectedInsurer,
  addInsurer,
  updateInsurer,
  deleteInsurer,
} = insurerSlice.actions;

export default insurerSlice.reducer;
